// import { useEffect, useState } from 'react'; // , useContext
import { Link } from 'react-router-dom';
// import DisplayRegistrations from '../../components/DisplayRegistrations';
// import axiosInstance from "../../helpers/Axios";
import type { IContact } from '../../interfaces/IContact';
import { useStages } from '../../contexts/StageContext';
import type { IStage } from '../../interfaces/IStage';
import '../../css/adminstage.scss';
import { Button, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

// const defaultList: ICourseObj[] = [];

// interface IDay {
//   name: string;
// }

// interface ICourse {
//   shortName: string;
//   name: string;
//   day: IDay;
//   isVisible: boolean;
//   startTime: string;
//   endTime: string;
// }

// interface ICourseObj {
//   course: ICourse;
//   subscribes: IContact[];
// }


interface IStageObj {
  stage: IStage;
  subscribes: IContact[];
}

interface StageContextType {
  list: IStageObj[];
  loading: boolean;
}
const Stages = () => {
  const stageContext: StageContextType = useStages();

  // const [list, setList] = useState(defaultList);
  // const [visible, setVisible] = useState(true);
  // const loading = list === defaultList && visible;

  // useEffect(() => {
  //   if (loading)
  //     axiosInstance.get("/course?withStudents=true")
  //       .then(response => {
  //         //console.log('response', response);

  //         setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
  //         // console.log("réponse",response.data);
  //         // setUserProfile(response.data);
  //         // setLocation(response.data.location);
  //       })
  //       .catch((err) => {
  //         const error = err.response === undefined ?
  //           'Server in not reachable'
  //           : err.response.data;
  //         console.log('error', error);
  //         setVisible(false);
  //       });
  // }
  // );

  // console.log("list", list);

  return (
    <div id="courses">
      <div id="title">
        <h1>Liste des stages existants</h1>
      </div>
      <div id="content">

        {stageContext.loading ?
          <p>Chargement en cours...</p>
          :
          <div>
            <Table className="stage-list">
              <TableHead>
                <TableRow>
                  <TableCell>Stage</TableCell>
                  <TableCell>Nom</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Prix</TableCell>
                  <TableCell>Visible</TableCell>
                  <TableCell>Annulé</TableCell>
                  <TableCell>Statut</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stageContext.list.length > 0 ?
                  stageContext.list.map((stage) => {
                    return <TableRow key={stage.stage.shortTitle}>
                      <TableCell>{stage.stage.shortName}</TableCell>
                      <TableCell>{stage.stage.name}</TableCell>
                      <TableCell>{stage.stage.date}</TableCell>
                      <TableCell>{stage.stage.price}</TableCell>
                      <TableCell>{stage.stage.isVisible ? 'Oui' : 'Non'}</TableCell>
                      <TableCell>{stage.stage.isCancelled ? 'Oui' : 'Non'}</TableCell>
                      <TableCell>{stage.stage.status}</TableCell>
                      <TableCell>
                        <Button 
                          variant="contained" 
                          color="primary" 
                          component={Link} 
                          to="update"
                          state= {{ stage: stage.stage }}
                          >
                          Modifier
                        </Button>
                      </TableCell>
                    </TableRow>
                  }) :
                  <div>
                    <p>Aucun stage n'a été trouvé.</p>
                  </div>
                }
              </TableBody>
            </Table>
            <Button color="primary" component={Link} to="new">
              Ajouter un stage
            </Button>
          </div>

        }
      </div>
    </div >
  )
};

export default Stages;



// {stageContext.list.length > 0 ?
//   stageContext.list.map((stage) => {
//     return <div key={stage.stage.shortTitle}>
//       <div >
//         {/* className={`${stage.stage.isCancelled ? 'strikethrough' : ''}`} */}
//         <Link className="stage-list-item" to="stages-week-ends">
//           <div id="stage" className="pane highlight">
//             <h3>{stage.stage.shortTitle}</h3>
//             <p>{stage.stage.date}</p>
//             <p>Salle 2 de l'Institut Sainte-Marie</p>
//             <p>227, rue de l'Aurore à 5100 Jambes</p>
//           </div>
//         </Link>
//       </div>
//       {
//         stage.stage.isCancelled ? <p className="cancelled">ANNULÉ</p> : <></>
//       }

//     </div>
//   }) :
//   <div>
//     <p>Le système d'inscription est actuellement en panne.</p>
//   </div>
// }
